const NUMERIC_TIMESTAMP_PATTERN = /^-?\d+(\.\d+)?$/;
const ISO_WITHOUT_TIMEZONE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
const SQL_TIMESTAMP_WITHOUT_TIMEZONE_PATTERN = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})(?:\.(\d+))?$/;
const UNIX_MILLISECONDS_THRESHOLD = 1000000000000;

const normalizeUtcTimestampString = (value) => {
  if (ISO_WITHOUT_TIMEZONE_PATTERN.test(value)) {
    return `${value}Z`;
  }

  const sqlMatch = value.match(SQL_TIMESTAMP_WITHOUT_TIMEZONE_PATTERN);
  if (sqlMatch) {
    const [, date, time, fractionalSeconds = ''] = sqlMatch;
    const milliseconds = fractionalSeconds
      ? `.${fractionalSeconds.padEnd(3, '0').slice(0, 3)}`
      : '';
    return `${date}T${time}${milliseconds}Z`;
  }

  return value;
};

export const toLocalDate = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const stringValue = String(value).trim();
  const timestamp = typeof value === 'number' || NUMERIC_TIMESTAMP_PATTERN.test(stringValue)
    ? Number(value)
    : null;

  if (timestamp !== null && Number.isFinite(timestamp)) {
    const milliseconds = Math.abs(timestamp) < UNIX_MILLISECONDS_THRESHOLD
      ? timestamp * 1000
      : timestamp;
    const date = new Date(milliseconds);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const valueToParse = normalizeUtcTimestampString(stringValue);
  const date = new Date(valueToParse);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatLocalDateTime = (value, options) => {
  const date = toLocalDate(value);
  return date ? date.toLocaleString(undefined, options) : '';
};

export const formatRelativeLocalTime = (value) => {
  const date = toLocalDate(value);
  if (!date) return '';

  const secondsAgo = Math.floor((Date.now() - date.getTime()) / 1000);
  const absoluteSeconds = Math.abs(secondsAgo);
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

  if (absoluteSeconds < 60) {
    return formatter.format(-secondsAgo, 'second');
  }

  if (absoluteSeconds < 3600) {
    return formatter.format(-Math.trunc(secondsAgo / 60), 'minute');
  }

  if (absoluteSeconds < 86400) {
    return formatter.format(-Math.trunc(secondsAgo / 3600), 'hour');
  }

  return formatter.format(-Math.trunc(secondsAgo / 86400), 'day');
};
